export const APP_VERSION = {
  name: '智慧小广',
  version: '0.2.1',
  date: '2026-08-17',
  description: '专项申请登录提交、反馈与申请处理闭环'
}
